<template>
    <v-card>
        <v-card-title>
            <div class="center">
                <chronometer :minutes-init="sendMinutes" :seconds-init="sendSeconds"></chronometer>
            </div>
        </v-card-title>
        <v-card-actions>
            <div class="center">
                <v-container grid-list-md text-xs-center>
                    <v-layout row wrap>
                        <v-flex xs4>
                            <v-text-field
                                    label="Minutes"
                                    v-model="minutes"
                                    mask="##"
                                    :rules="rules.minutes"
                                    :count="4"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                            <ig-text-field
                                    label="Seconds"
                                    v-model="secondsValue"
                                    :rules="rules.max60"
                                    mask="##"
                                    :count="4"
                                    :status="true"
                            ></ig-text-field>
                        </v-flex>
                        <v-flex xs4>
                            <v-btn ripple @click="send()">Reset</v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
        </v-card-actions>
    </v-card>
</template>

<script>
import chronometer from './chronometer'

export default {
  name: 'v-card-chronometer',
  components: {
    chronometer
  },
  props: {
    minutesInit: {
      type: Number,
      default: 4,
      required: false
    },
    secondsInit: {
      type: Number,
      default: 0,
      required: false
    }
  },
  watch: {
    minutesInit: function (val) {
      this.minutes = val
      this.send()
    },
    secondsInit: function (val) {
      this.seconds = val
      this.send()
    }
  },
  data () {
    return {
      minutes: 0,
      seconds: 0,
      rules: {
        minutes: [v => { return (parseInt(v) < 60 && parseInt(v) > 0) || 'El valor debe estar entre 1 y 59' }],
        max60: [v => { return (parseInt(v) < 60 && parseInt(v) >= 0) || 'El valor debe estar entre 0 y 59' }]
      },
      sendMinutes: 4,
      sendSeconds: 0
    }
  },
  mounted () {
    this.minutes = this.minutesInit
    this.seconds = this.secondsInit
    this.send()
  },
  methods: {
    send () {
      this.sendMinutes = parseInt(this.minutes)
      this.sendSeconds = parseInt(this.seconds)
    }
  },
  computed: {
    secondsValue: {
      get: function () {
        return this.seconds.toString()
      },
      set: function (value) {
        if (value) {
          this.seconds = parseInt(value)
        }
      }
    }
  }
}
</script>

<style scoped>
    .center {
        text-align: center;
        margin: auto;
    }
</style>
